import { Link, NavLink } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { useCart } from "../context/CartContext";
import { useAuth } from "../context/AuthContext";

const links = [
  { to: "/shop", label: "Shop", testid: "nav-shop-link" },
  { to: "/orders", label: "Orders", testid: "nav-orders-link" },
  { to: "/refunds", label: "Returns", testid: "nav-returns-link" },
];

export default function Header() {
  const { count, setOpen } = useCart();
  const { user, logout } = useAuth();
  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-black/75 border-b border-white/10"
    >
      <div className="px-4 sm:px-8 lg:px-16 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo-link" className="font-display font-extrabold tracking-tighter text-lg uppercase">
          Noir<span className="text-[#FF334B]">/</span>Archive
        </Link>
        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              className={({ isActive }) =>
                `mono text-xs uppercase tracking-[0.25em] transition-colors hover:text-[#FF334B] ${
                  isActive ? "text-[#FF334B]" : "text-zinc-400"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-6">
          {user ? (
            <>
              <span data-testid="account-email-label" className="hidden md:inline mono text-[10px] tracking-[0.2em] text-zinc-500 uppercase">
                {user.email}
              </span>
              <button
                data-testid="logout-button"
                onClick={logout}
                className="mono text-xs uppercase tracking-[0.25em] text-zinc-300 hover:text-[#FF334B] transition-colors"
              >
                Sign Out
              </button>
            </>
          ) : (
            <Link
              to="/auth"
              data-testid="nav-signin-link"
              className="mono text-xs uppercase tracking-[0.25em] text-zinc-300 hover:text-[#FF334B] transition-colors"
            >
              Sign In
            </Link>
          )}
          <button
            data-testid="cart-open-button"
            onClick={() => setOpen(true)}
            className="relative flex items-center gap-2 mono text-xs uppercase tracking-[0.25em] text-zinc-300 hover:text-[#FF334B] transition-colors"
          >
            <ShoppingBag size={18} />
            <span className="hidden sm:inline">Bag</span>
            {count > 0 && (
              <span
                data-testid="cart-count-badge"
                className="absolute -top-2 -right-3 bg-[#FF334B] text-white text-[10px] w-4 h-4 flex items-center justify-center"
              >
                {count}
              </span>
            )}
          </button>
        </div>
      </div>
    </header>
  );
}
